"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cep_pipe_1 = require("./../../pipe/cep.pipe");
var TxAddressInputComponent = /** @class */ (function () {
    function TxAddressInputComponent() {
        this.setPipes();
    }
    TxAddressInputComponent.prototype.ngOnInit = function () {
    };
    TxAddressInputComponent.prototype.setAddressState = function (value) {
        this.address.state = value;
    };
    TxAddressInputComponent.prototype.applyCepMask = function (event) {
        return this.cepPipe.transform(event.target.value, event.key);
    };
    TxAddressInputComponent.prototype.setPipes = function () {
        this.cepPipe = new cep_pipe_1.CepPipe();
    };
    TxAddressInputComponent.ctorParameters = function () { return []; };
    return TxAddressInputComponent;
}());
exports.TxAddressInputComponent = TxAddressInputComponent;
//# sourceMappingURL=tx-address-input.component.js.map


// WEBPACK FOOTER //
// tx-address-input.component.js